/** Whether the app is running a development build (mockable in tests). */
export function isDevelopment(): boolean {
    return process.env.NODE_ENV === 'development';
}
